// extracted by mini-css-extract-plugin
export default {"timerButton":"TimerButton_timerButton__ziI6z","button":"TimerButton_button__bzk-0"};